module.exports = __webpack_public_path__ + "static/media/june2024-3.e753bb00.webp";